module.exports = __webpack_public_path__ + "img/riekkola_maisema2.797e2cd2.jpg";